import React from 'react';

function WebDevWorkflowSection() {
  const handleDiscussClick = (e) => {
    e.preventDefault();
    const formEl = document.getElementById('webdev-hero-form') || document.querySelector('.contact-section');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  return (
    <section className="webdev-workflow-section">
      <div className="container webdev-workflow-container">
        {/* Left Column: Content */}
        <div className="webdev-workflow-left">
          <h2 className="webdev-workflow-title">
            Our Smooth & Efficient <span className="webdev-red-text">Web Design and Development</span> Workflow
          </h2>

          <p className="webdev-workflow-desc">
            We use a tried and true four step <a href="/web-design/" className="webdev-red-link">web design</a> and development methodology that guarantees timely delivery, performance, and clarity. The way we work means excellence from beginning to end, whether you're searching for WordPress website development, <a href="/ecommerce-web-development/" className="webdev-red-link">e-commerce web design</a>, or custom website creation. We understand how important it is for you to have an interesting and efficient website. Our experienced web design and development team works professionally to create custom websites to meet your specific needs.
          </p>

          <button className="btn-webdev-discuss" onClick={handleDiscussClick}>
            Let's Discuss Your Needs
          </button>
        </div>

        {/* Right Column: Image */}
        <div className="webdev-workflow-right">
          <div className="webdev-workflow-img-wrapper">
            <img 
              src="/assets/images/web-dev/web-img1.png" 
              alt="Our Smooth & Efficient Web Design and Development Workflow" 
              className="webdev-workflow-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default WebDevWorkflowSection;
